module.exports = __webpack_public_path__ + "img/bgp05.086bc9dd.jpg";